import { render } from "./UiModal.vue?vue&type=template&id=0f00a8d4"
import script from "./UiModal.vue?vue&type=script&lang=js"
export * from "./UiModal.vue?vue&type=script&lang=js"

import "./UiModal.vue?vue&type=style&index=0&id=0f00a8d4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__